import React from "react";
import { useFormContext } from "react-hook-form";
import { FormDropdown, mapToDropdownOption, NamedProperty, FormShimmer, Stack } from "sprint-common-web";

import { CloudFileAssociationFormState } from "../../context/CloudFileAssociationContext";
import { useCloudFileAssociationSection } from "../../context/useCloudFileAssociationSection";
import { useCloudFileAssociationVideoTechnicalDetailsOptions } from "./useCloudFileAssociationVideoTechnicalDetailsOptions";

export const CloudFileAssociationVideoTechnicalDetailsForm = (): JSX.Element => {
    const {
        isEditDisabled,
        selectedVideoTechnicalDetails,
        setSelectedVideoTechnicalDetails
    } = useCloudFileAssociationSection();
    const { control, errors } = useFormContext<CloudFileAssociationFormState>();

    const {
        aspectRatios,
        areAspectRatiosLoading,
        aspectTypes,
        areAspectTypesLoading
    } = useCloudFileAssociationVideoTechnicalDetailsOptions();

    return (
        <FormShimmer isLoading={areAspectRatiosLoading || areAspectTypesLoading}>
            <Stack>
                <FormDropdown
                    options={mapToOptions(aspectRatios)}
                    label="Aspect ratio"
                    name="selectedVideoTechnicalDetails.aspectRatioId"
                    disabled={isEditDisabled}
                    onChange={(v) =>
                        setSelectedVideoTechnicalDetails({
                            ...selectedVideoTechnicalDetails,
                            aspectRatioId: v || null
                        })
                    }
                    control={control}
                    errors={errors}
                />

                <FormDropdown
                    options={mapToOptions(aspectTypes)}
                    label="Aspect type"
                    name="selectedVideoTechnicalDetails.aspectTypeId"
                    disabled={isEditDisabled}
                    onChange={(v) =>
                        setSelectedVideoTechnicalDetails({ ...selectedVideoTechnicalDetails, aspectTypeId: v || null })
                    }
                    control={control}
                    errors={errors}
                />
            </Stack>
        </FormShimmer>
    );
};

const mapToOptions = (items: NamedProperty[]) => items.map((i) => mapToDropdownOption(i));
